import { render, staticRenderFns } from "./ExEmployeeToPreparePosition.vue?vue&type=template&id=2b47d2f5&scoped=true"
import script from "./ExEmployeeToPreparePosition.vue?vue&type=script&setup=true&lang=js"
export * from "./ExEmployeeToPreparePosition.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ExEmployeeToPreparePosition.vue?vue&type=style&index=0&id=2b47d2f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b47d2f5",
  null
  
)

export default component.exports